import { Component, ViewChild, ElementRef } from "@angular/core";

@Component({
    selector: "app-loading",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.css"],
    standalone: false,
})
export class LoadingComponent {
    @ViewChild("image") image: ElementRef;
    @ViewChild("loading") loading: ElementRef;

    public isLoading: boolean | null = null;
    private spinner: any; // NodeJS.Timer

    public startLoading = async () => {
        this.isLoading = true;
        this.showBackdrop();
        this.spinStart();
        this.spinner = setInterval(this.spinStart, 2000);
    };

    public endLoading = async () => {
        this.isLoading = false;
        this.hideBackdrop();
        clearInterval(this.spinner);
    };

    private spinStart = () => {
        this.image.nativeElement.style.transform = "rotate(360deg)";
        setTimeout(this.spinEnd, 1000);
    };

    private spinEnd = () => {
        this.image.nativeElement.style.transform = "";
    };

    private showBackdrop = () => {
        this.loading.nativeElement.style.opacity = "1";
        this.loading.nativeElement.style["z-index"] = "50";
    };

    private hideBackdrop = () => {
        this.loading.nativeElement.style["z-index"] = "-1";
        this.loading.nativeElement.style.opacity = "0";
    };
}
